import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl, storeId } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const couponsApi = createApi({
  reducerPath: 'couponsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Coupons'],
  endpoints: (builder) => ({
    get: builder.query({
      query: ({ page, perPage, preSell, albumId }) => {
        const params = {}

        if (page) {
          params.page = page
        }

        if (perPage) {
          params.per_page = perPage
        }

        if (albumId) {
          params.album = albumId
        }

        if (preSell) {
          params.pre_sell = 'true'
        }

        return { url: `stores/${storeId}/coupons`, params, method: 'GET' }
      },
      providesTags: (results) => {
        if (!results) {
          return [{ type: 'Coupons', id: 'LIST' }]
        }
        return [...results.data.map((i) => ({ type: 'Coupons', id: i.id })), { type: 'Coupons', id: 'LIST' }]
      },
    }),
    add: builder.mutation({
      query: (coupon) => ({ url: 'coupons', method: 'POST', body: coupon }),
      invalidatesTags: (results, error, { id }) => {
        return [{ type: 'Coupons', id }]
      },
    }),
    delete: builder.mutation({
      query: (coupon) => ({ url: `coupons/${coupon.id}`, method: 'DELETE' }),
      invalidatesTags: (results, error, { id }) => {
        return [{ type: 'Coupons', id }]
      },
    }),
  }),
})

export const { useGetQuery, useAddMutation, useDeleteMutation } = couponsApi

export default couponsApi
